import { $ui } from '../functions';

export namespace $twitter {
    export function share(url: string, text?: string, user?: string) {
        let href = 'https://twitter.com/intent/tweet?url=' + encodeURIComponent(url);
        if(text)
            href += '&text=' + encodeURIComponent(text);
        if(user)
            href += '&via=' + encodeURIComponent(user);
        $ui.openWindow(href, { width: 500, height: 300 });
    }
}